




import Vue from 'vue';

import { getConfig } from '@/web/utils/configuration';

export default Vue.extend({
  computed: {
    logoHeight() {
      return {
        height: getConfig()['admin-logo-height'],
      };
    },
  },
  data() {
    return {
      logo: getConfig()['admin-logo'],
    };
  },
});
